import { PROFILE } from '../../../constants/strings';

export default (type, value, formatMessage) =>
  formatMessage(PROFILE.notificationSettings.label, {
    type: formatMessage(PROFILE.notificationSettings.labels[type]),
    value,
  });



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/getLabel.js